import React from 'react';
import App from './App';
import './DefectTrackerApp.css';

function DefectTrackerApp() {
  return (
    <div className="defect-tracker-wrapper">
      <App />
    </div>
  );
}

export default DefectTrackerApp;
